// extracted by mini-css-extract-plugin
export default {"label":"FilterLabel_label__heqGU"};